import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.VUE_APP_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children:[
        {
          path: '/',
          component: ()=> import('@/views/BrowserHome.vue')
        },
        {
          path: '/BrowserHome/:page/:ves*',
          name: 'BrowserHome',
          component: ()=> import('@/views/BrowserHome.vue')
        },
        {
          path: '/HyperblockView/:hid/:page*',
          name: 'HyperblockView',
          component: ()=> import('@/views/HyperblockView.vue')
        },
        {
          path: '/LocalchainView/:hid/:chainNum/:page*',
          name: 'LocalchainView',
          component: ()=> import('@/views/LocalchainView.vue')
        },
        {
          path: '/LocalblockView/:hid/:chainNum/:id/:page*',
          name: 'LocalblockView',
          component: ()=> import('@/views/LocalblockView.vue')
        },
        {
          path: '/TxView/:TxID',
          name: 'TxView',
          component: ()=> import('@/views/TxView.vue')
        },
        {
          path: '/TxList/:address([^/]*)?/:page(\\w+)?',
          name: 'TxList',
          component: ()=> import('@/views/TxList.vue')
        }                
      ]
    },
    {
      path: '/home',
      component: Home
    },
    // {
    //   path: "*",
    //   beforeEnter(to, from, next){
    //     var language = localStorage.getItem("language");
    //     if(language == "zh"){
    //       window.location = "@/../public/index.html";
    //       return;
    //     }
    //     window.location = "@/../public/en/index.html";
    //   } 
    // }
  ]
})
